export type BufferUnits = 'ft' | 'yd' | 'mi' | 'NM' | 'm' | 'km';

export class BufferSrc {
	buffer!: number;
	units!: BufferUnits;
	value!: number;
	constructor(buffer: number, units: BufferUnits) {
		this.Update(buffer, units);
	}
	static ConvertFromMeters(value: number, units: BufferUnits): number {
		switch (units) {
			case 'ft':
				return value * 3.28084;
			case 'yd':
				return value * 1.09361;
			case 'mi':
				return value * 0.0006213671;
			case 'NM':
				return value * 0.000539957;
			case 'm':
				return value;
			case 'km':
				return value * 0.001;
		}
	}
	static FromMeters(value: number, units: BufferUnits): BufferSrc {
		return new BufferSrc(BufferSrc.ConvertFromMeters(value, units), units);
	}
	static Convert(bufferSrc: BufferSrc) {
		switch (bufferSrc.units) {
			case 'ft':
				bufferSrc.value = bufferSrc.buffer / 3.28084;
				break;
			case 'yd':
				bufferSrc.value = bufferSrc.buffer / 1.09361;
				break;
			case 'mi':
				bufferSrc.value = bufferSrc.buffer / 0.0006213671;
				break;
			case 'NM':
				bufferSrc.value = bufferSrc.buffer / 0.000539957;
				break;
			case 'm':
				bufferSrc.value = bufferSrc.buffer;
				break;
			case 'km':
				bufferSrc.value = bufferSrc.buffer / 0.001;
				break;
		}
	}
	Update(buffer: number, units: BufferUnits) {
		this.buffer = buffer;
		this.units = units;
		BufferSrc.Convert(this);

	}
	Add(src: BufferSrc): BufferSrc {
		if (!src) {
			return this;
		}
		return BufferSrc.FromMeters(this.value + src.value, this.units);
	}

}
